import React from "react"
import { connect } from "react-redux"
import { numberCounterCellConnection } from "sheets/selectors/column-selectors"
import { Counter } from "quorumdesign"
import { formatNumberCounter } from "shared/imports/sharedHelperFunctions"

/**
 * NumberCounterCell takes in a number and returns a blue DesignSystem Counter with a
 * string representing the abbreviated value. When hovered, the Counter expands horizontally
 * and shows the raw value of the number.
 *
 * @param  {Number} value
 */
export const NumberCounterCell = ({ value, opacity, ...props }) => (
    <div className="number-counter">
        <Counter
            value={value}
            roundingFn={formatNumberCounter}
            opacity={opacity}
            size="small"
            flexDirection="column"
            dynamic
            cursor="pointer"
        />
    </div>
)

export default connect((state, props) => numberCounterCellConnection(state, props), {})(NumberCounterCell)
